import { ActionReducerMap } from '@ngrx/store';
import { generalSettingsReducer } from './general-settings/general-settings.reducer';
import { userDetailsReducer } from './user-details/user-details.reducer';
import { IGeneralSettingsState } from './general-settings/general-settings.state';
import { IUserDetailsState } from './user-details/user-details.state';

export interface AppState {
  generalSettings: IGeneralSettingsState; // generalSettings interface'inizi buraya ekleyin
  userDetails: IUserDetailsState; // userDetails interface'inizi buraya ekleyin
}

export const StoreReducers: ActionReducerMap<AppState> = {
  generalSettings: generalSettingsReducer,
  userDetails: userDetailsReducer,
};
